import React from 'react';
import LazyLoad from 'react-lazyload';
import { useHomeBusinessStyles } from '../../../styles/organisms/home-business.styles';
import { GetInTouchMolecule, IconThreeCirclesMolecule } from '../../molecules';
import { HomeBusinessProps } from './home-business.props';

export const HomeBusinessOrganism = (props: HomeBusinessProps) => {
  const classes = useHomeBusinessStyles();
  return (
    <>
      <section
        className={`block bg-white w-full ${classes.bgBlueWhiteGradient}`}
        id="HowCanHelp"
      >
        <div className="bg-waldo-dirty-white mx-auto w-11/12 lg:w-4/5 block py-10 lg:py-12">
          <h2 className="text-center w-56 lg:w-full mx-auto">
            How will we grow <span className="underline">your business?</span>
          </h2>

          <div className="w-17/20 mx-auto block lg:hidden bg-waldo-dirty-white mt-5 mb-10 ">
            <LazyLoad offset={350} height={350}>
              <img
                src="/images/home/products/eye_examine_mobile.png"
                className="w-full"
              />
            </LazyLoad>
          </div>

          <div className="flex flex-col-reverse lg:flex-row w-full lg:w-9/10 mx-auto justify-between items-stretch mt-0 lg:mt-12">
            <div className="w-11/12 lg:w-3/10 mx-auto lg:mx-0 px-5 lg:px-3  bg-waldo-dirty-white text-waldo-blue">
              <div className="border-t border-waldo-blue pt-4 text-base">
                <h5 className="text-h_5 font-waldo-sans font-medium">
                  High Quality Lenses
                </h5>
                <p className="block text-sm mt-2">
                  Allowing you to offer high quality lenses in-house for the
                  same low price as online means we’ll bring patients who may
                  have otherwise left your office looking for inexpensive,
                  low-quality options,{' '}
                  <span className="font-medium inline-block">back to you</span>.
                </p>
                <div className="my-5 pt-3 lg:pt-0">
                  <LazyLoad offset={100} height={100}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-full"
                      viewBox="0 0 254.457 48.717"
                    >
                      <g
                        id="Group_574"
                        data-name="Group 574"
                        transform="translate(-465.945 -2424.083)"
                      >
                        <g
                          id="Group_557"
                          data-name="Group 557"
                          transform="translate(466.5 2424.583)"
                        >
                          <path
                            id="Path_143"
                            data-name="Path 143"
                            d="M177.609,248.772l.059.082c-3.207,9.754-15.8,17.033-30.847,17.033s-27.64-7.278-30.848-17.033l.059-.082Z"
                            transform="translate(-115.973 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_144"
                            data-name="Path 144"
                            d="M217.383,248.772c-3.787,9.17-15.971,15.88-30.419,15.88a42.146,42.146,0,0,1-17.231-3.534,41.044,41.044,0,0,0,19.7,4.768c15.047,0,27.64-7.278,30.848-17.033l-.059-.082Z"
                            transform="translate(-158.584 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                        </g>
                        <g
                          id="Group_558"
                          data-name="Group 558"
                          transform="translate(560.805 2424.583)"
                        >
                          <path
                            id="Path_143-2"
                            data-name="Path 143"
                            d="M177.609,248.772l.059.082c-3.207,9.754-15.8,17.033-30.847,17.033s-27.64-7.278-30.848-17.033l.059-.082Z"
                            transform="translate(-115.973 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_144-2"
                            data-name="Path 144"
                            d="M217.383,248.772c-3.787,9.17-15.971,15.88-30.419,15.88a42.146,42.146,0,0,1-17.231-3.534,41.044,41.044,0,0,0,19.7,4.768c15.047,0,27.64-7.278,30.848-17.033l-.059-.082Z"
                            transform="translate(-158.584 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                        </g>
                        <g
                          id="Group_559"
                          data-name="Group 559"
                          transform="translate(658.152 2424.583)"
                        >
                          <path
                            id="Path_143-3"
                            data-name="Path 143"
                            d="M177.609,248.772l.059.082c-3.207,9.754-15.8,17.033-30.847,17.033s-27.64-7.278-30.848-17.033l.059-.082Z"
                            transform="translate(-115.973 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                          <path
                            id="Path_144-3"
                            data-name="Path 144"
                            d="M217.383,248.772c-3.787,9.17-15.971,15.88-30.419,15.88a42.146,42.146,0,0,1-17.231-3.534,41.044,41.044,0,0,0,19.7,4.768c15.047,0,27.64-7.278,30.848-17.033l-.059-.082Z"
                            transform="translate(-158.584 -248.772)"
                            fill="none"
                            stroke="#0032a0"
                            strokeWidth="1"
                          />
                        </g>
                        <text
                          id="low_price"
                          data-name="low price"
                          transform="translate(473.5 2467.8)"
                          fill="#0032a0"
                          className="text-xs font-waldo-sans font-normal"
                        >
                          <tspan x="0" y="0">
                            low price
                          </tspan>
                        </text>
                        <text
                          id="high_quality"
                          data-name="high quality"
                          transform="translate(563.5 2467.8)"
                          fill="#0032a0"
                          className="text-xs font-waldo-sans font-normal"
                        >
                          <tspan x="0" y="0">
                            high quality
                          </tspan>
                        </text>
                        <text
                          id="in-office"
                          transform="translate(668.5 2467.8)"
                          fill="#0032a0"
                          className="text-xs font-waldo-sans font-normal"
                        >
                          <tspan x="0" y="0">
                            in-office
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </LazyLoad>
                </div>
              </div>
              <div className="border-t border-waldo-blue py-4 text-base">
                <h5 className="text-base font-waldo-regular font-medium">
                  WALDO Marketing Team
                </h5>
                <p className="text-sm mt-2">
                  We acquire new, engaged customers everyday as a result of our
                  advertising campaigns. In partnering with us you’ll share our
                  wins, <span className="font-medium">without the cost</span>.
                </p>
                <div className=" pt-7 lg:pt-4">
                  <LazyLoad offset={200} height={200}>
                    <img
                      src="/images/home/icons/graph.png"
                      className="w-full"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
            <div className="w-9/25 bg-white self-stretch hidden lg:flex ">
              <div className="self-end">
                <LazyLoad offset={400} height={400}>
                  <img src="/images/home/products/eye_examine.png" />
                </LazyLoad>
              </div>
            </div>
            <div className="w-11/12 lg:w-3/10 mx-auto lg:mx-0 px-5 lg:px-5  bg-waldo-dirty-white text-waldo-blue ">
              <div className="border-t border-waldo-blue pt-4 text-base">
                <h5 className="text-base font-waldo-regular font-medium">
                  Doctor Network
                </h5>
                <p className="text-sm mt-2">
                  By inviting you to join our doctor network, we’ll connect you
                  with patients near you needing eye exams, and direct them
                  <span className="font-medium"> straight to your office.</span>
                </p>
                <div className="my-5 pt-3 lg:pt-0">
                  <LazyLoad offset={100} height={100}>
                    <img
                      src="/images/home/icons/doctor-network.svg"
                      className="w-full"
                    />
                  </LazyLoad>
                </div>
              </div>
              <div className="border-t border-waldo-blue pt-5 pb-4  text-base">
                <h5 className="text-base font-waldo-regular font-medium">
                  Affordable Subscription
                </h5>
                <p className="text-sm mt-2">
                  By offering affordable, flexible subscription plans that work
                  seamlessly around patients lifestyles, our subscription
                  process is designed for the long-term - which means a lifetime
                  lens option for wearers, and
                  <span className="font-medium"> retention for you.</span>
                </p>
                <div className="mt-0 lg:mt-1 pt-3">
                  <LazyLoad offset={100} height={100}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-full mb-5"
                      viewBox="0 0 260 23.466"
                    >
                      <g
                        id="Group_500"
                        data-name="Group 500"
                        transform="translate(-56.5 -3961.555)"
                      >
                        <path
                          id="Path_344"
                          data-name="Path 344"
                          d="M276.293,50.016H25.042V73.482H276.293c4.832,0,8.749-5.254,8.749-11.733S281.124,50.016,276.293,50.016Z"
                          transform="translate(31.458 3911.539)"
                          fill="#0057b7"
                        />
                        <text
                          id="lifetime"
                          transform="translate(167.5 3976.729)"
                          fill="#fff"
                          className="font-waldo-sans font-light text-xs"
                        >
                          <tspan
                            x="0"
                            y="0"
                            className="font-waldo-sans text-xs"
                          >
                            lifetime
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </LazyLoad>
                  <LazyLoad offset={100} height={100}>
                    <IconThreeCirclesMolecule />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mx-auto w-11/12 lg:w-4/5 block">
        <GetInTouchMolecule label={props.cta} addClass="pt-10 lg:pt-14 pb-5" />
      </div>
    </>
  );
};
